import Icon from '@components/dataDisplay/Icons/Icon';
import React from 'react';
import styled from 'styled-components';

const BtnWrapper = styled.div`
  width: 100%;
  padding: 12px 0;
  border-radius: 8px;
  transition: background 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 13px;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background: var(--inkColor);
  }
`;

type Props = {
  onClick: () => void;
  hidden: boolean;
};
function SeeMoreBtn({ onClick, hidden }: Props) {
  if (hidden) return null;
  return (
    <BtnWrapper onClick={onClick}>
      더 보기
      <Icon name="ArrowDown12" />
    </BtnWrapper>
  );
}

export default SeeMoreBtn;
